// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: t_Fj9N8hGsIl
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicFolderUploaderHeader.module.css"; // plasmic-import: t_Fj9N8hGsIl/css

createPlasmicElementProxy;

export const PlasmicFolderUploaderHeader__VariantProps = new Array();

export const PlasmicFolderUploaderHeader__ArgProps = new Array();

const $$ = {};

function PlasmicFolderUploaderHeader__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox___5Tlba)}>
        <div
          data-plasmic-name={"closeButton"}
          data-plasmic-override={overrides.closeButton}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.closeButton
          )}
        >
          {"X"}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__c1JDh)}>
        <div
          data-plasmic-name={"closeButton2"}
          data-plasmic-override={overrides.closeButton2}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.closeButton2
          )}
        >
          {
            "Upload a folder containing the documentation files for your debtors. Ensure that the account ID or the debtor's full name is in the title of each file."
          }
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "closeButton", "closeButton2"],
  closeButton: ["closeButton"],
  closeButton2: ["closeButton2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFolderUploaderHeader__ArgProps,
          internalVariantPropNames: PlasmicFolderUploaderHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFolderUploaderHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFolderUploaderHeader";
  } else {
    func.displayName = `PlasmicFolderUploaderHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicFolderUploaderHeader = Object.assign(
  // Top-level PlasmicFolderUploaderHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeButton: makeNodeComponent("closeButton"),
    closeButton2: makeNodeComponent("closeButton2"),
    // Metadata about props expected for PlasmicFolderUploaderHeader
    internalVariantProps: PlasmicFolderUploaderHeader__VariantProps,
    internalArgProps: PlasmicFolderUploaderHeader__ArgProps
  }
);

export default PlasmicFolderUploaderHeader;
/* prettier-ignore-end */
